import { render, staticRenderFns } from "./StockTrfNew_Items.vue?vue&type=template&id=4b52e877&"
import script from "./StockTrfNew_Items.vue?vue&type=script&lang=js&"
export * from "./StockTrfNew_Items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports